<template>
    <div class="white-wrapper">
        <main class="privacy">
            <div class="privacy__wrapper">
                <div class="privacy__big-title">
                    <span>Gizlilik</span>
                </div>
                <div class="privacy__description">
                    <div class="col-12" style="text-align: center;">
                        <p>
                            <b>RECKITT BENCKISER - GLOBAL GİZLİLİK POLİTİKASI</b>
                        </p>
                        <p>
                        Reckitt Benckiser'in Global Gizlilik Politikası'na ("<b>Gizlilik Politikası</b>") hoş geldiniz.
                        </p>
                        <p>
                            Reckitt Benckiser olarak gizliliğinizi korumayı taahhüt ediyoruz. Bu
                            Gizlilik Politikası, Türkiye'deki tüm faaliyetlerimiz için geçerli olup
                            Kişisel Verileri'inizi nasıl topladığımızı, kullandığımızı, ifşa ettiğimizi
                            ve koruduğumuzu açıklamaktadır.
                        </p>
                        <p>
                            Belirli Sitelere veya Hizmetlere özgü olan gizlilik politikalarının, bu
                            Gizlilik Politikası'nı tamamlayabileceğini veya yerini alabileceğini lütfen
                            unutmayınız.
                        </p>
                        <p>
                        Bu Gizlilik Politikası'nda yer alan "<b>biz</b>", "<b>bize</b>" ve "<b>bizim</b>" ifadeleri, Türkiye'de Veri Sorumlusu sayılan Reckitt
                        Benckiser Ev ve Hijyen Ürünleri A.Ş. dahil tüm Reckitt Benckiser grup
                        şirketlerini ifade etmektedir. Bizim hakkımızda ve markalarımız ile ilgili
                        daha fazla bilgi için, lütfen <a href="http://www.rb.com/" target="_blank">www.rb.com</a> adresini
                        ziyaret ediniz.
                        </p>
                        <p>
                            "<b>Kişisel Veriler</b>" ile (bazı ülkelerde "kişisel bilgiler" veya
                            "kişiyi tanımlayan bilgiler" olarak anılır), belirli veya belirlenebilir
                            bir gerçek kişiyle ilgili herhangi bilgi ifade edilmektedir. Bu, kişisel
                            veya özel nitelikteki bilgiden daha geniş bir anlamı ifade eder ve adınız,
                            doğum tarihiniz ve e-posta adresiniz gibi bilgileri de içerir.
                        </p>
                        <p>
                            <b>Hızlı Başvuru Kılavuzu</b>
                        </p>
                        <p>
                            1. Gizlilik Politikamızın kapsamı
                        </p>
                        <p>
                            2. Onayınız
                        </p>
                        <p>
                            3. Kişisel Bilgilerinizi nasıl topluyoruz?
                        </p>
                        <p>
                            4. Kişisel Bilgilerinizi hangi amaçlarla kullanabiliriz?
                        </p>
                        <p>
                            5. Kişisel Bilgilerinizi kimlerle paylaşabiliriz?
                        </p>
                        <p>
                            6. Kişisel Bilgilerinizi nasıl koruyoruz?
                        </p>
                        <p>
                            7. Doğrudan pazarlama ile ilgili seçimleriniz
                        </p>
                        <p>
                            8. Kişisel Bilgilerinize nasıl erişebilir, düzeltebilir veya
                            silebilirsiniz?
                        </p>
                        <p>
                            9. Kişisel Bilgilerinizi ne kadar süreyle muhafaza ediyoruz?
                        </p>
                        <p>
                            10. Çocuklar
                        </p>
                        <p>
                            11. Diğer ülkelere aktarım
                        </p>
                        <p>
                            12. Gizlilik Politikamızda yapılacak değişiklikler
                        </p>
                        <p>
                            13. Bizimle nasıl iletişime geçebilirsiniz?
                        </p>
                        <p>
                            <b>1. Gizlilik Politikamızın Kapsamı</b>
                        </p>
                        <p>
                            Gizlilik Politikamız, bu Gizlilik Politikası'nı gösteren, buna link veren
                            veya atıfta bulunan hem çevrimiçi hem çevrimdışı faaliyetlerimiz
                            aracılığıyla topladığımız, kullandığımız, paylaştığımız veya başkaca
                            şekilde işlemiş olduğumuz tüm Kişisel Veriler'e uygulanmaktadır. Bu
                            faaliyetlere şunlar da dahildir:
                        </p>
                        <p>
                            • internet sitelerimiz
                        </p>
                        <p>
                            • resmi sosyal medya sayfalarımız
                        </p>
                        <p>
                            • e-postalarımız
                        </p>
                        <p>
                            • çevrimiçi ve çevrimdışı kampanyalarımız
                        </p>
                        <p>
                            • temsilcilerimizle olan ve kayıt altına alınan telefon görüşmeleriniz veya
                            yazışmalarınız.
                        </p>
                        <p>
                            Bu belge içerisinde çevrimiçi faaliyetlerimiz "<b>Siteler</b>" ve
                            çevrimdışı faaliyetlerimiz ise "<b>Hizmetler</b>" olarak anılacaktır.
                        </p>
                        <p>
                            Sitelerimizde, tarafımızca kontrol edilmeyen ve işbu Gizlilik Politikası
                            kapsamında bulunmayan üçüncü şahıs internet sitelerine, uygulamalarına vb.
                            yönlendirme yapan bağlantılar (<i>hyperlink</i>) bulunabileceğine lütfen
                            dikkat ediniz. Bu tür üçüncü şahıs web sitelerinin, uygulamaların ve benzer
                            <s>
                                <del>i</del>
                            </s>
                            lerin içeriği ve faaliyetleri ile ilgili herhangi bir sorumluluğumuz veya
                            yükümlülüğümüz bulunmamaktadır. Bu tür üçüncü şahıslar, Kişisel
                            Verilerinizi toplayabileceği için bunların Kişisel Verilerinizi nasıl
                            kullandığı ile ilgili daha fazla bilgi için bu üçüncü şahısların gizlilik
                            politikalarını okumanızı öneririz.
                        </p>
                        <p>
                            <b>2. Onayınız</b>
                        </p>
                        <p>
                            Kişisel Verilerinizi, websitemizde bulunan Aydınlatma Metni çerçevesinde
                            belirli bir amaçla işleyebilmek için Kişisel Verilerin Korunması Kanunu'nda
                            belirtilen hukuka uygunluk sebeplerine, bu sebeplerden herhangi birinin
                            bulunmaması halinde ise de sizden aldığımız açık rızaya dayanıyoruz.
                        </p>
                        <p>
                            Kişisel Verilerinizi sadece adil ve yasal olan durumlarda toplar, kullanır,
                            ifşa eder veya işleriz.
                        </p>
                        <p>
                            Kişisel Verilerinizi bizimle paylaşmayı tercih etmemeniz durumunda bizden
                            talep ettiğiniz ürünleri ve hizmetleri size sağlayamayabileceğimizi
                            belirtmek isteriz.
                        </p>
                        <p>
                            <b>3. Kişisel Verilerinizi nasıl topluyoruz?</b>
                        </p>
                        <p>
                            <i>Doğrudan sizden elde edilen kişisel bilgiler</i>
                        </p>
                        <p>
                            <i> </i>
                        </p>
                        <p>
                            Öncelikle, Kişisel Verilerinizi doğrudan sizden temin edebiliriz, örneğin,
                            haber bültenlerimize kaydolurken, Sitemize kayıt yaptırırken, bizden bir
                            ürün satın alırken, anket doldururken, bir yorum yaparken veya soru
                            sorduğunuzda, sosyal medya sayfalarımızda bir şeyler yayınlarken, vb.
                        </p>
                        <p>
                            Bu şekilde toplanan Kişisel Veriler şunları içerebilir:
                        </p>
                        <p>
                            • isim
                        </p>
                        <p>
                            • adres
                        </p>
                        <p>
                            • e-posta adresi
                        </p>
                        <p>
                            • telefon numarası
                        </p>
                        <p>
                            • Sitelere yüklediğiniz kullanıcı tarafından üretilen içerikler, mesajlar
                            ve diğer içerikler
                        </p>
                        <p>
                            • doğrudan bize temin ettiğiniz diğer Kişisel Bilgiler.
                        </p>
                        <p>
                            <i>Otomatik olarak toplanan Kişisel Bilgiler</i>
                        </p>
                        <p>
                            İkinci olarak, bazı Kişisel Veriler, Sitelerimizi ziyaret ettiğinizde veya
                            kullandığınızda otomatik olarak toplanabilir, örneğin, çerezler ve diğer
                            teknolojiler tarafından web sitelerimizde toplanan bilgiler gibi.
                        </p>
                        <p>
                            Bu şekilde toplanan Kişisel Veriler şunları içerebilir:
                        </p>
                        <p>
                            • (mobil) cihazınız veya tarayıcınızın türü hakkında bilgiler;
                        </p>
                        <p>
                            • web sitelerimizi kullanma şekliniz hakkında bilgiler, örneğin,
                        görüntülediğiniz web sayfalarına, tıkladığınız reklam bantlarına (<i>banner</i>) ve köprü bağlatılarına (<i>hyperlink</i>) ilişkin ayrıntılar
                            gibi;
                        </p>
                        <p>
                            • tarafımızdan gönderilen e-postaları açıp açmadığınız;
                        </p>
                        <p>
                            • web sitelerimizden birine gelmeden önce ziyaret ettiğiniz web siteleri;
                        </p><br>
                        <p>
                            • IP adresiniz;
                        </p>
                        <p>
                            • web sitelerimize yerleştirilen sosyal medya araçlarını kullanarak
                            paylaşmayı seçtiğiniz bilgiler;
                        </p>
                        <p>
                            • İzin verdiyseniz, kesin konum verileriniz.
                        </p>
                        <p>
                            <i>Diğer kaynaklardan elde edilen Kişisel Veriler</i>
                        </p>
                        <p>
                            Son olarak, Kişisel Verileri, güvenilir iş ortaklarımız gibi diğer
                            kaynaklardan da elde edebiliriz.
                        </p>
                        <p>
                            Bu şekilde toplanan Kişisel Bilgiler, gelir seviyesini, hobiler ve evcil
                            hayvanlar gibi ilgi alanlarınızı, tüketici ve pazar araştırması verilerini,
                            satın alma davranışını, kamuya açıklanmış olan verileri veya bloglar,
                            videolar, internet gönderileri ve kullanıcı tarafından oluşturulmuş
                            içerikler gibi eylemleri içerebilir.
                        </p>
                        <p>
                            <b>4. Kişisel Verilerinizi hangi amaçlarla kullanabiliriz?</b>
                        </p>
                        <p>
                            Kişisel Verilerinizi aşağıdaki hallede olduğu gibi iş amaçlı olarak
                            kullanabiliriz:
                        </p>
                        <p>
                            • satın alma işlemlerinizi gerçekleştirmek ve yürütmek, örneğin, satın alma
                            işleminizle ilgili olarak size bilgi vermek, ödemelerinizi işleme almak,
                            satın alınan ürünleri ve hizmetleri sağlamak ve gereken müşteri hizmetini
                            sizlere sunmak; - KVKK md. 5/2 - c
                        </p>
                        <p>
                            • promosyonlara, yarışmalara, anketlere ve oylamalara katılımınıza imkan
                            sağlamak; KVKK md. 5/2 - c ve f
                        </p>
                        <p>
                            • sosyal medya sayfalarımızda, forumlarımızda, bloglarımızda ve diğer
                            iletişim kanallarımızda bilgi ve fikir paylaşımında bulunabilmenize,
                            Sitelerimiz veya güvenilir iş ortaklarımızın web siteleri üzerinden sosyal
                            paylaşıma katılabilmenize ve bir arkadaşınıza mesaj gönderebilmenize imkan
                            sağlamak; - KVKK md. 5/2 c ve f
                        </p>
                        <p>
                            • ihtiyaçlarınızı daha iyi anlayarak sizlere daha uygun bilgi verebilmek,
                            kurumsal faaliyetlerimizi analiz etmek ve değerlendirmek, yeni ürünler
                            geliştirmek ve mevcut ürünlerimizi ve hizmetlerimizi geliştirmek, pazar
                            araştırması ve denetimleri yürütmek, kullanıcı eğilimlerini belirlemek ve
                            pazarlama kampanyalarımızın etkinlik derecesini ve müşterilerimizin
                            memnuniyet derecesini incelemek; - KVKK md. 5/2 f
                        </p>
                        <p>
                            • sizlere ürünlerimizden ve hizmetlerimizden bahsetmek; ve markalarımıza ve
                            dikkatle seçilmiş güvenilir iş ortaklarımıza ilişkin tanıtım materyallerini
                            (örneğin, yeni ürünlere, promosyonlars, tasarruf programlarına, ortak
                            promosyonlara ve diğer programlarımıza ilişkin duyurular gibi) sizler ile
                            paylaşmak; KVKK md. 5/1 veya KVKK md. 5/2 f
                        </p>
                        <p>
                            • Sitelerimizi yönetmek, buradaki deneyiminizi kişiselleştirmek amacıyla
                            Sitedeki önceki hareketleriniz ile Sitelerimizdin deneyimini ve
                            içeriklerini uyumlu hale getirmek; KVKK md. 5/2 f
                        </p>
                        <p>
                            - talep veya sorularınıza cevap verebilmek. KVKK md. 5/2 c ve ç.
                        </p>
                        <p>
                            Kişisel Verilerinizi satmıyoruz.
                        </p>
                        <p>
                            Kişisel olarak sizi belirlenebilir kılan verileri (örneğin isminiz gibi
                            bilgileri) hariç tutarak Kişisel Bilgilerden anonim veri kayıtları
                            oluşturabiliriz. Bu anonim verileri, ürünlerimizi ve hizmetlerimizi analiz
                            etmek için kullanırız. Bu tür anonim verileri tamamen kendi takdirimize
                            bağlı olarak herhangi bir amaçla kullanma ve araştırma ortaklarımız dahil
                            ancak bunlarla sınırlı olmaksızın üçüncü şahıslara açıklama hakkımız
                            saklıdır.
                        </p>
                        <p>
                            <b>5.</b>
                            <b> </b>
                            <b> Kişisel Verilerinizi kimlerle paylaşabiliriz?</b>
                        </p>
                        <p>
                            <i>Grup şirketler içerisinde paylaşım</i>
                        </p>
                        <p>
                            Kişisel Verileriniz, bu Gizlilik Politikasında belirtilen amaçlar
                            doğrultusunda şirketler grubumuzda yer alan farklı şirketler ve markalar
                            arasında paylaşılabilir. Yukarıda belirttiğimiz gibi, bu Gizlilik
                            Politikası tüm bu şirketler ve markalar için geçerlidir.
                        </p>
                        <p>
                            <i>Üçüncü şahıs hizmet sağlayıcıları</i>
                        </p>
                        <p>
                            Kişisel Verilerinizi, bizim adımıza çalışan pazarlama ajansları, pazar
                            araştırma şirketleri, e-ticaret iş ortakları, yazılım sağlayıcıları, RB
                            ürünleri satan tacirler, çağrı merkezleri, ödeme işlemcileri vb. gibi
                            güvenilir üçüncü şahıs hizmet sağlayıcıları ile paylaşabiliriz. Bu üçüncü
                            şahıs hizmet sağlayıcılarının, bizden talep ettiğiniz hizmetlerin
                            sağlanabilmesi dışında Kişisel Verilerinizi kullanmamaları istenmektedir.
                        </p>
                        <p>
                            <i>Devralmalar</i>
                        </p>
                        <p>
                            <i> </i>
                        </p>
                        <p>
                            Bir başka şirket, şirketimizi, işimizi veya varlıklarımızı (veya bunların
                            bir kısmını) devraldığı takdirde, tarafımızca toplanmış olan Kişisel
                            Verilerin de tamamını veya bir bölümünü alabilir ve bu Gizlilik
                            Politikasında tanımlanan Kişisel Verilerinizle ilgili hak ve yükümlülükleri
                            üstlenir.
                        </p>
                        <p>
                            <i>Gerekli açıklamalar</i>
                        </p>
                        <p>
                            <i> </i>
                        </p>
                        <p>
                            Açıklamanın gerekli olduğuna kanaat ettiğimiz durumda Kişisel Verilerinizi
                            aşağıdaki hallerde açıklayabiliriz:
                        </p>
                        <p>
                            • herhangi bir yasal soruşturma ile bağlantılı olarak;
                        </p>
                        <p>
                            • ilgili kanunlara uygunluk amacıyla veya tarafımıza tebliğ edilen mahkeme
                            kararlarına, celp ve müzekkerelere cevaben;
                        </p>
                        <p>
                            • haklarımızı koruma veya savunma amacıyla;
                        </p>
                        <p>
                            • hukukun, işbu Gizlilik Politikası'nın veya uygulanabilir Kullanım
                            Şartları'nın herhangi bir şekilde ihlalinin veya olası ihlalinin
                            araştırılması veya engellenebilmesi amacıyla.
                        </p>
                        <p>
                            <b>6.</b>
                            <b> </b>
                            <b> Kişisel Verilerinizi nasıl koruyoruz?</b>
                        </p>
                        <p>
                            Bize duyduğunuz güvene değer veriyoruz.
                        </p>
                        <p>
                            Kişisel Verilerinizi, yanlışlıkla veya hukuka aykırı olarak imha edilmesi
                            veya yanlışlıkla kaybolması, değiştirilmesi, yetkisiz biçimde açıklanması
                            veya erişim sağlanması ve başkaca hukuka aykırı biçimlerde işlenmesi
                            ihtimallerine karşı korumak amacıyla uygun teknik ve yapısal önlemler
                            aldık.
                        </p>
                        <p>
                            Hassas bilgileri toplarken veya aktarırken ise Kişisel Verilerinizin
                            korunmasına yardımcı olmak amacıyla çeşitli ek güvenlik teknolojileri ve
                            prosedürlerinden yararlanmaktayız.
                        </p>
                        <p>
                            Bize verdiğiniz Kişisel Verileriniz, bilgisayar sistemlerinde saklanmakta
                            olup bu sistemler, kontrol altında tutulan tesislerde yerleşiktir ve
                            yalnızca sizin tarafınızdan talep edilen hizmetleri ve görevleri yerine
                            getirilebilmesi için bilgiyi öğrenmesi gereken sınırlı sayıda kişi
                            tarafından erişilebilirdir.
                        </p>
                        <p>
                            İnternet üzerinden yüksek derecede gizli bilgileri (örneğin, kredi kartı
                            numaraları gibi) işlerken ise şifreleme yöntemiyle koruma sağlıyoruz.
                        </p>
                        <p>
                            <b>7.</b>
                            <b> </b>
                            <b> Doğrudan pazarlama ile ilgili seçimleriniz</b>
                        </p>
                        <p>
                            E-posta veya başka bir elektronik kanal aracılığıyla rıza göstermişseniz,
                            sizin için uygun olduğunu düşündüğümüz ürünlerimiz ve hizmetlerimizle
                            ilgili ücretsiz bülten, anket, teklif ve diğer tanıtım materyallerini
                            periyodik olarak gönderebiliriz.
                        </p>
                        <p>
                            Bu türden iletişimleri artık almak istemiyorsanız, doğrudan pazarlama
                            e-postalarımızın her birinde veya SMS gibi diğer elektronik iletişimlerde
                            yer alan aboneliği iptal etme talimatlarını izleyerek veya doğrudan bize
                            (aşağıdaki iletişim bilgilerinden) ulaşarak "devre dışı bırakma (opt-out)"
                            imkanına her zaman sahipsiniz.
                        </p>
                        <p>
                            Belirtilen e-posta tercihlerinize rağmen size Gizlilik Politikamıza yönelik
                            güncelleme bildirimlerini gönderebiliriz.
                        </p>
                        <p>
                            <b>8. Kişisel Verilerinize nasıl erişebilir, düzeltebilir veya
                                silebilirsiniz?
                            </b>
                        </p>
                        <p>
                            Kişisel Verilerinizi doğru ve güncel tutmaya özen gösteriyoruz.
                        </p>
                        <p>
                            Size, kendi Kişisel Verilerinize makul biçimde erişme ve inceleme imkanı
                            ile uygun şekilde bunları düzeltme ve silme talebinde bulunma imkânı
                            sunuyoruz.
                        </p>
                        <p>
                            Gizliliğinizi koruyabilmek için, Kişisel Verilerinize erişim izni vermeden
                            önce kimliğinizi doğrulayabilmek için makul önlemler alıyoruz.
                        </p>
                        <p>
                            Size ait Kişisel Veriler hakkında bilgi almak ve bunlar üzerinde değişiklik
                            yapmak için ilgili Sitedeki talimatları izleyebilirsiniz.
                        </p>
                        <p>
                            Bize başvurarak:
                        </p>
                        <p>
                            - tarafımızca herhangi bir Kişisel Verinizin işlenip işlenmediği konusunda
                            bilgi alabilirsiniz;
                        </p>
                        <p>
                            - Kişisel Verilerinizin işlenme amacını ve amacına uygun şekilde kullanılıp
                            kullanılmadığı konusunda bilgi alabilirsiniz;
                        </p>
                        <p>
                            - Kişisel Verilerinizin yurtiçi veya yurtdışında aktarıldığı üçüncü kişiler
                            hakkında bilgi alabilirsiniz;
                        </p>
                        <p>
                            - Kişisel Verileriniz eksik veya hatalıysa bunların değişitirilmesini yahut
                            silinmesini veya yok edilmesini talep edebilirsiniz;
                        </p>
                        <p>
                            - Kişisel Verilerinizin aktarıldığı üçüncü şahıslara, Kişisel Verşlerinizin
                            değiştirildiği, silindiği veya yok edildiğinin bildirilmesini talep
                            edebilirsiniz;
                        </p>
                        <p>
                            - Kişisel Verilerinizin münhasıran otomatik sistemler vasıtasıyla işlenmesi
                            suretiyle aleyhine ortaya çıkan sonuçlara itiraz edebilirsiniz; ve
                        </p>
                        <p>
                            - Kişisel Verilerinizin kanuna aykırı şekilde işlenmesi sebebiyle zarara
                            uğramanız halinde zararın giderilmesini talep edebilirsiniz.
                        </p>
                        <p>
                            Taleplerinize talebin bize ulaştığı tarihten itibaren 30 gün içerisinde ve
                            yürürlükte olan mevzuatta belirtilen kurallara uygun olarak cevap
                            vereceğiz.
                        </p>
                        <p>
                            <b>9. Kişisel Verilerinizi ne kadar süreyle muhafaza ediyoruz?</b>
                        </p>
                        <p>
                            Kişisel Verilerinizi, yalnızca yukarıda belirtilen amaçlar dahilinde makul
                            olarak gerekli olduğu sürece muhafaza edeceğiz. Detaylı bilgi için
                        Sitemizde bulunan <a>Kişisel Veri Saklama ve İmha Politikamızı </a>
                            inceleyebilirsiniz.
                        </p>
                        <p>
                            <b>10. Çocuklar</b>
                        </p>
                        <p>
                            Sitelerimizin çoğu, çocuklara yönelik değildir ve 18 yaşın altındaki
                            çocukların Sitelerimiz aracılığıyla Kişisel Verilerini vermemesini rica
                            ederiz.
                        </p>
                        <p>
                            Eğer Sitelerimizden birinde kayıtlı olan veya başkaca şekilde bize Kişisel
                            Verilerini iletmiş 18 yaşın altındaki bir çocuğun ebeveyni veya yasal
                            koruyucusu iseniz, lütfen bu bilgilerin silinebilmesi için bize +90 212 326
                            9838 numaralı telefondan ulaşın. Çocukların kendi iradeleriyle e-posta,
                            mesaj panosu, sohbet oturumları vb. yollarla verdikleri bilgiler, diğer
                            kişilerce istenmeyen e-postaların oluşturulmasında kullanılabilir.
                            Ebeveynlerin ve yasal koruyucuların, interneti güvenli ve sorumlu bir
                            şekilde nasıl kullanacakları konusunda çocuklarını bilgilendirmeleri
                            konusunda teşvik ederiz.
                        </p>
                        <p>
                            <b>11. Diğer ülkelere aktarım</b>
                        </p>
                        <p>
                            Kişisel Verileriniz, hukuka uygun bir şekilde açık rızanız dahilinde
                            diğer ülkelere aktarılabilir ve burada işlenebilir.
                        </p>
                        <p>
                            Kişisel Verilerinizin hangi ülkede saklandığı veya işlendiğinden bağımsız
                            olarak Kişisel Verilerinizin uygun şekilde korunması için sıkı yöntemler ve
                            kontroller uygulamaktayız.
                        </p>
                        <p>
                            <b>12. Gizlilik Politikamızda yapılacak değişiklikler</b>
                        </p>
                        <p>
                            Bu Gizlilik Politikasını zaman zaman güncelleyebiliriz. Güncelleme
                            olduğunda, bu Gizlilik Politikasının en üstünde yer alan tarih de
                            güncellenecektir. Gizlilik Politikamızda gizlilik uygulamalarımızı büyük
                            ölçüde değiştiren önemli değişiklikler olması durumunda, yapılacak
                            güncelleme hakkında değişiklikler yürürlüğe girmeden evvel sizlere başkaca
                            yollarla önden bildirimde bulunabiliriz; örneğin, bize verdiğiniz son
                            e-posta adresiniz üzerinden veya kurumsal web sitemizde ve/veya sosyal
                            medya sayfamızda bildirim şeklinde olabilir. Lütfen Gizlilik Politikası'nın
                            en son versiyonuna bakıp bakmadığınızı her zaman doğrulayınız. Sitelerimizi
                            ve Hizmetlerimizi kullanmaya devam etmeniz durumunda işbu Gizlilik
                            Politikasını ve tüm güncellemeleri kabul etmiş sayılırsınız.
                        </p>
                        <p>
                            <b>13. Bizimle nasıl iletişime geçebilirsiniz?</b>
                        </p>
                        <p>
                            Bu Gizlilik Politikası ile ilgili yorumlarınız veya sorularınız bizim için
                            önemlidir.
                        </p>
                        <p>
                            <br/>
                            Bize +90 212 327 9700 numaralı telefondan ulaşabilir veya
                            <a href="mailto:Turkey.ConsumerRelations@rb.com" target="_blank">
                                Turkey.ConsumerRelations@rb.com</a>
                            adresi üzerinden iletişime geçebilirsiniz.
                        </p>
                        <p><b>Kişisel Verilerin Korunması Hakkında Aydınlatma Bildirimi</b></p>
                        <p>&nbsp;</p>
                        <p>Bu
                            bilgilendirme, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”)
                            10. maddesi gereğince ve yasal zorunluluk nedeniyle yapılmaktadır.</p>
                        <p>Reckitt
                            Benckiser Ev ve Hijyen Ürünleri &nbsp;A.Ş. (“RB”) olarak kişisel
                            verilerinizin güvenliği ve korunması hususlarına büyük bir önem
                            göstermekteyiz. Bu bilinçle, RB olarak her
                            türlü kişisel verinin 6698 sayılı KVKK’ya uygun olarak işlenmesi ve
                            muhafaza edilmesi konusuna azami hassasiyet göstermekteyiz.</p>
                        <p>KVKK’da
                            belirtildiği üzere RB tarafından veya RB’nin talimatı ile işlenmekte olan
                            kişisel veriler bakımından “Veri Sorumlusu” sıfatıyla sorumlu olduğumuz
                            bilincinde olarak, kişisel verilerinizi aşağıda izah edildiği şekilde ve
                            mevzuat tarafından izin verilen sınırlamalar çerçevesinde işlemekteyiz.</p>
                        <p><b>&nbsp;</b></p>
                        <p><b>1. Veri Sorumlusu</b></p>
                        <p>KVKK
                            uyarınca kişisel verileriniz Veri Sorumlusu olarak Reckitt Benckiser
                            Ev ve Hijyen Ürünleri A.Ş tarafından aşağıda açıklananlar kapsamında
                            işlenebilecektir.</p>
                        <p>&nbsp;</p>
                        <p><b>2. Kişisel Verilerin Toplanması, İşlenmesi ve İşleme Amaçları</b></p>
                        <p>Kişisel
                            verileriniz, RB tarafından sağlanan www.yarininsuyu.com isimli web sitesi üzerinden 
                            otomatik olan yollarla ve doğrudan sizden toplanacaktır.</p>
                        <p>&nbsp;</p>
                        <p>Toplanan kişisel verileriniz, internet sitemiz üzerinden yaptığımız çalışmalar 
                            ve su tüketim alışkanlıklarınıza ilişkin size yönelttiğimiz sorular aracılığıyla 
                            farkındalığınızın yaratılması ve su tüketiminizin en aza indirilmesi amaçlarıyla 
                            işlenecektir. Bu veriler ayrıca RB’nin ürünlerinin tanıtımı, tasarlanması ve 
                            piyasa konumlandırması amacıyla da işlenecektir. Ayrıca RB ürünleriyle ilgili 
                            konularda bizimle iletişime geçmeniz dahilinde de kişisel verileriniz yukarıdaki 
                            amaçlar kapsamında işlenebilecektir. Son olarak, birtakım verileriniz web 
                            sitesinde yer alan çerezler aracılığı ile de toplanabilir ve işlenebilir. 
                            Çerezler ile ilgili detaylı bilgi için lütfen Çerez Politikamızı inceleyiniz.</p>
                        <p>Toplanan kişisel verileriniz; RB tarafından hukuka ve dürüstlük kurallarına uygun, 
                            doğru ve gerektiğinde güncel, belirli, açık ve meşru amaçlar için ve işlendikleri 
                            amaçla bağlantılı, sınırlı ve ölçülü olarak ve ilgili mevzuatta öngörülen veya 
                            işlendikleri amaç için gerekli olan süre kadar muhafaza edilme ilkelerine uygun 
                            olarak işlenir.</p>
                        <p><b>&nbsp;</b></p>
                        <p><b>3. İşlenen Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği</b></p>
                        <p>Toplanan kişisel verileriniz; 2. maddede belirtilen amaçlarla sınırlı olarak, hukuka uygunluk sebebinin bulunduğu hallerde yurtiçi / yurtdışı iştiraklerimiz ve RB’nin hizmet/destek/danışmanlık aldığı kurum ve kuruluşlarla paylaşılabilir aktarabilir.</p>
                        <p>RB kişisel verilerinizi, yukarıda belirtilen amaçlar çerçevesinde gerekli güvenlik önlemlerin almak kaydıyla, Türkiye içinde veya dışında bulunan sunucularda veya diğer elektronik ortamlarda işleyip saklayabilecektir. </p>
                        <p>&nbsp;</p>
                        <p><b>4. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi</b></p>
                        <p>Kişisel
                            verileriniz, RB tarafından veya RB’nin sözleşmeli olarak birlikte
                            çalıştığı diğer 3. kişilerce sözlü, yazılı ya da elektronik ortamda ve 
                            yukarıdaki 2. ve 3. maddelerde yer verilen amaçlar doğrultusunda aşağıda 
                            belirtilen hukuka uygunluk sebepleri çerçevesinde işlenebilecek ve 
                            aktarılabilecektir.</p>
                        <p>• İlgili kişiden açık rıza alınması – KVKK m. 5/1 a</p>
                        <p>• Veri Sorumlusu’nun meşru menfaati - KVKK m. 5/2 f</p>
                        <p>&nbsp;</p>
                        <p><b>5. İlgili Kişi Olarak Haklarınız</b></p>
                        <p>İlgili kişi olarak, haklarınıza ilişkin taleplerinizi, aşağıda
                            düzenlenen yöntemlerle Veri Sorumlusu’na iletmeniz durumunda, talebinizi
                            niteliğine göre en kısa sürede ve en geç otuz gün içinde herhangi bir
                            ücret talep etmeksizin sonuçlandıracaktır. Ancak, Kişisel Verileri
                            Koruma Kurulunca, başvurulara ilişkin bir ücret öngörülmesi durumunda,
                            belirlenecek ilgili ücret alınacaktır.</p>
                        <p>&nbsp;</p>
                        <p>KVKK’nın 11. maddesine göre ilgili kişi olarak haklarınız şunlardır;</p>
                        <p>&nbsp;</p>
                        <p>a) Kişisel veri işlenip işlenmediğini öğrenme,</p>
                        <p>b) Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</p>
                        <p>c) Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını
                            öğrenme,</p>
                        <p>d) Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,</p>
                        <p>e)
                            Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların
                            düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerin
                            aktarıldığı üçüncü kişilere bildirilmesini isteme,</p>
                        <p>f) KVKK’ya ve
                            ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen,
                            işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel
                            verilerin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan
                            işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini
                            isteme,</p>
                        <p>g) İşlenen verilerin münhasıran otomatik sistemler
                            vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir
                            sonucun ortaya çıkmasına itiraz etme,</p>
                        <p>h) Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın
                            giderilmesini talep etme</p>
                        <p>&nbsp;</p>
                        <p>Veri Sorumlusu KVKK’da
                            olabilecek değişiklikler ve Kişisel Verileri Koruma Kurulu tarafından
                            belirlenecek yöntemler ile verilecek kararlar sebebi ile bu aydınlatma
                            bildiriminde değişiklik yapma hakkını saklı tutmaktadır.</p>
                        <br>
                        <p>&nbsp;</p>
                        <p>
                            <a href="/pdf/ilgili-kisi-basvuru-formu.pdf" target="_blank">EK – 1: İlgili Kişi Başvuru Formu</a>
                        </p>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "Privacy",
        mounted() {
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'subPage');
        }
    }
</script>

<style lang="scss">


    $base-width: 1140px;
    $icon-font: "Font Awesome 5 Free";


    .white-wrapper {

        background-color: white;
        width: 100%;
    }

    .privacy {

        min-height: calc(100vh - 121px);
        color: black;

        &__wrapper {
            width: 666px;
            margin: 0 auto;
        }

        &__big-title {
            font-size: 25px;
            font-weight: bold;
            color: black;
            display: flex;
            justify-content: center;
            margin: 30px 0;
        }

        &__description {
            margin-bottom: 50px;
        }
    }


    @media screen and (max-width: 600px) {
        .privacy {

            &__wrapper {
                width: 100%;
            }

            &__description {
                padding: 0 20px;
            }
        }
    }
</style>